var map = {
	"./app-store-icon.svg": 4695,
	"./appgallery-icon.svg": 1684,
	"./arrow-right-icon.svg": 5476,
	"./back-icon.svg": 8941,
	"./checkbox.svg": 8231,
	"./google-play-icon.svg": 4420,
	"./ru-store-icon.svg": 1458,
	"./telegram-icon.svg": 8622,
	"./viber-icon.svg": 2101,
	"./website.svg": 3276,
	"./whatsapp-icon.svg": 1715
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;